import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { KindRootNodeStoreContext } from './contexts/StoreContext'
import { KindRootNodeStoreProviderProps } from './interface'
import { createKindRootNodeStore } from './store/createStore'
import { KindRootNodeStoreUpdater } from './StoreUpdater'

export const KindRootNodeStoreProvider = <M extends boolean>({
  children,

  /* -------------------------------------------------------------------------- */
  /*                       KindRootNodeStoreUpdater Props                       */
  /* -------------------------------------------------------------------------- */
  memberType,
  multiple,
  value,
  onChange
}: PropsWithChildren<KindRootNodeStoreProviderProps<M>>) => {
  const store = useCreation(() => createKindRootNodeStore(), [])

  return (
    <KindRootNodeStoreContext value={store}>
      <KindRootNodeStoreUpdater
        memberType={memberType}
        multiple={multiple}
        value={value}
        onChange={onChange}
      />
      {children}
    </KindRootNodeStoreContext>
  )
}
